export enum ConceptType {
    HetaArbeten = 1,
    BrandfarligaArbeten = 2,
    Denmark = 3,
    Finland = 4,
    Norway = 5,
    Other = 6,
}
